import { Mathematics } from '../app/mathematics';

export interface IKpi {
  name: string;
  currentValue: number;
  previousValue: number;
  hasData: boolean;
  compute(a: any[], b: any[]): IKpi;
  format(decimals: number): IKpi;
  convert(conversionFunction: Function, prevConversionFunction: Function): IKpi;
}

export class Kpi implements IKpi {
  name: string;
  currentValue = 0;
  previousValue = 0;
  hasData = false;
  unit = '';

  constuctor(name: string, unit: string) {
    this.name = name;
    this.unit = unit;
  }

  compute(currentEntries: any[], previousEntries: any[]): IKpi {
    return this;
  }

  convert(currentConvertion: Function, previousConversion?: Function): IKpi {
    this.currentValue = currentConvertion(this.currentValue);
    this.previousValue = previousConversion(this.previousValue);
    return this;
  }

  format(decimals: number): IKpi {
    this.currentValue = Number(this.currentValue.toFixed(decimals));
    this.previousValue = Number(this.previousValue.toFixed(decimals));
    return this;
  }
}

/**
 *
 */
export class SumKpi extends Kpi {
  constructor(name: string) {
    super();
    this.name = name;
  }

  compute(currentEntries: any[], previousEntries: any[]): IKpi {
    currentEntries = currentEntries
      .filter(kpi => kpi['name'] === this.name)
      .map(kpi => kpi['value']).filter(value => (value !== null && value !== undefined));
    previousEntries = previousEntries
      .filter(kpi => kpi['name'] === this.name)
      .map(kpi => kpi['value']).filter(value => (value !== null && value !== undefined));
    if (currentEntries.length > 0) {
      this.hasData = true;
      this.currentValue = Mathematics
        .arraySum(currentEntries);
      if (previousEntries.length > 0) {
        this.previousValue = Mathematics
          .arraySum(previousEntries);
      }
    }
    return this;
  }
}

export class AverageKpi extends Kpi {

  constructor(name: string) {
    super();
    this.name = name;
  }

  compute(currentEntries: any[], previousEntries: any[]): IKpi {
    //const currentEntriesTotalLength = currentEntries.length;
    //const previousEntriesTotalLength = previousEntries.length;
    currentEntries = currentEntries
      .filter(kpi => kpi['name'] === this.name)
      .map(kpi => kpi['value']).filter(value => (value !== null && value !== undefined));
    previousEntries = previousEntries.filter(kpi => kpi['name'] === this.name)
      .map(kpi => kpi['value']).filter(value => (value !== null && value !== undefined));

    if (currentEntries.length > 0) {
      this.hasData = true;
      this.currentValue = Mathematics.arraySum(currentEntries) / currentEntries.length;
      if (previousEntries.length > 0) {
        this.previousValue = Mathematics.arraySum(previousEntries) / currentEntries.length;
      }
    }
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/kpi.ts